<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template v-slot:datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template v-slot:data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :search="slot_props.search"
                :should_show_raw_html_header="should_show_raw_html_header"
                :show_download_pdf_btn="true"
                :show_footer="false"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            >
                <template v-slot:table_description>
                    <div>
                        閃電警示<br>
                        燈號說明：<br>
                        紅燈 <span class="description-dot" style="background: #f00;"></span> 0-10km有閃電發生<br>
                        閃電資料來源：氣象署
                    </div>
                    <br>
                    <div>
                        QPE警示<br>
                        燈號說明：<br>
                        紅燈 <span class="description-dot" style="background: #f00;"></span> 0-10km有QPE大於40mm<br>
                        QPE資料來源：氣象署
                    </div>
                    <br>
                    <div>
                        對流胞警示<br>
                        燈號說明：<br>
                        紅燈 <span class="description-dot" style="background: #f00;"></span> (紅燈)0-10km有對流胞在範圍內<br>
                        對流胞資料來源：氣象署
                    </div>
                </template>
            </QpeDatatable>
        </template>

    </MonitorLayoutTemplate>
</template>

<script>
    import {redirect_monitor_table_ajax} from "@/utils/monitor/monitor.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js";
    import cloneDeep from 'lodash/cloneDeep'
    import { TABLE_VALUE_TEXT_MAPPING } from "@/config/monitor_config.js"
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import QpeDatatable from "@/components/monitor/qpe_datatable.vue";

	export default {
        name: 'tra_lightning',

        components: {
            MonitorLayoutTemplate,
            QpeDatetime,
            QpeDatatable,
        },

        mixins: [monitor_mixin],
      
		data() {
			return {
                header: [],
                immutable_table_data: [],
                table_data: [],
                default_value: 232,
                error_text: '',

                should_show_raw_html_header: ['閃電警示', 'QPE警示', '對流胞警示'],
                
                search: ''
            }
        },

        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            }
        },
        
        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

		methods: {
            generate_table_data(data, header) {
                this.immutable_table_data = data
                this.table_data = this.reconstruct_alert_icon(this.sort_table_data(data));
                this.header = header;
            },

            sort_table_data(data_array) {
                return [...data_array].sort((a, b) => {
                    const countDiff =
                        this.get_warning_count(b) - this.get_warning_count(a)

                    if (countDiff !== 0) return countDiff

                    // 次排序：閃電優先
                    if (a['閃電警示'] === '有' && b['閃電警示'] !== '有') return -1
                    if (a['閃電警示'] !== '有' && b['閃電警示'] === '有') return 1

                    return 0
                })
            },
            get_warning_count(item) {
                const warning_keys = ['閃電警示', 'QPE警示', '對流胞警示']

                return warning_keys.reduce((count, key) => {
                    return count + (item[key] === '有' ? 1 : 0)
                }, 0)
            },

            reconstruct_alert_icon(data) {
                return cloneDeep(data).map(datum => {
                    let instead_obj = {}
                    const warning_keys = ['閃電警示', 'QPE警示', '對流胞警示']
                    warning_keys.forEach((key) => {
                        if(datum[key] === '有') {
                            instead_obj[key] = [{
                                'html': `<span class="dot" style="background: #FF0000" />`
                            }]
                        }
                    })

                    if(Object.keys(instead_obj).length) return Object.assign(datum, instead_obj)
                    return datum
                });
            },
        },
	}
</script>